<template>
  <div class="smokeAlarmAuto">
    <div class="fireeye-body">
      <el-form label-width="100px">
        <h1 class="fireeye-h1">报警信息</h1>
        <div class="fireeye-bg fireeye-info">
          <i class="el-icon-time"></i>
          <span>{{ alarmInfo.alarmSingle.alarmTime }}</span>
          <i class="el-icon-location-outline"></i>
          <span>{{ alarmInfo.alarmSingle.disasterAddress }}</span>
        </div>
        <h1 class="fireeye-h1">选择出警人员</h1>
        <div class="fireeye-bg fireeye-personnel">
          <el-checkbox-group v-model="selectCjPersons">
            <el-row :gutter="32"  >
              <label style="font-size: 18px;width: 13%; float: left;padding:10px 0px 10px 10px;">社区消防员:</label>
              <div style="float:left;font-size: 18px;width: 86%;">
                <span v-for="(item,index) in cjPersons" :key="index" style="display:inline-block;minWidth:33.3%">
                  <el-checkbox :label="item" :key="item.id">{{ item.uname }}
<!--                    ({{ item.region }}) -->
                  </el-checkbox>
                </span>
              </div>
            </el-row>

            <!-- <el-row :gutter="32" >
              <label style="padding:10px;font-size: 18px;width: 14%; float: left;">社区协警:</label>
              <el-col :span="4" v-for="(item,index) in cjPersons1"  :key="index" v-if="item!=null">
                <el-checkbox :label="item" :key="item.id">{{ item.name }}</el-checkbox>
              </el-col>
            </el-row>

            <el-row :gutter="32" >
              <label style="padding: 10px;font-size: 18px;width: 14%; float: left;">社区民警:</label>
              <el-col :span="4" v-for="(item,index) in cjPersons2" :key="index" v-if="item!=null">
                <el-checkbox :label="item" :key="item.id">{{ item.name }}</el-checkbox>
              </el-col>
            </el-row>

            <el-row :gutter="32"  >
              <label style="padding:10px;font-size: 18px;width: 13%; float: left;">防火监督员:</label>
              <el-col :span="4" v-for="(item,index) in cjPersons3" :key="index" v-if="item!=null">
                <el-checkbox :label="item" :key="item.id">{{ item.name }}</el-checkbox>
              </el-col>
            </el-row> -->
          </el-checkbox-group>
        </div>
        <!-- <h1 class="fireeye-h1">请选择出警装备即数量</h1>
        <div class="fireeye-bg fireeye-num">

          <el-checkbox-group v-model="selectEqus" autofocus="true">
           <el-row :gutter="32">
            <el-col :span="12"  v-for="(item,index) in equs" :key="index">

              <span style="display:inline-block;width:45%;">
                <el-checkbox :label="item" :key="item.id">{{ item.ename }}({{item.znumber}})</el-checkbox>
              </span>
              <span :span="12" style="margin-top:10px">
                <el-input-number
                  v-model="item.num"
                  :step="1"
                  size="small"
                  :min="0"
                  style="margin-left:5px;"
                ></el-input-number>
              </span>
             </el-col>
          </el-row>
          </el-checkbox-group>
        </div> -->
      </el-form>
    </div>
    <div slot="footer" class="fireeye-footer">
      <el-button @click="police">出 警</el-button>
    </div>

    <!-- 火场文书 -->
    <el-dialog
      :visible.sync="fireDocuDialog"
      :close-on-click-modal="falseStr"
      :close-on-press-escape="falseStr"
      width="80%"
      class="fireDoc"
      :title="pinkName"
      center
      append-to-body
			@close="closeFireProbe()"
      >
      <fire-pink-alarm
				v-if="fireBookDialog"
        ref="firePinkAlarm"
        :dataFinish="dataFinish"
        :alarmId="alarmId1"
        @closeFirePinkAlarm="closeFirePinkAlarm"
      ></fire-pink-alarm>
      >
    </el-dialog>
  </div>
</template>
<script>
import firePinkAlarm from "@/pages/fireBook/firePinkAlarm";
import gaodemap from "@/pages/gaodemap/gaodemap";

export default {
  name:'firePink',
  props: {
    alarmId: {
      type: String,
      default: ''
    },
    q: {
      type: Object
    }
  },
  components: {
    firePinkAlarm,
    gaodemap,
  },
  data() {
    return {
      alarmId1:'',
      dispathOrderDialog: false,
      fireDocuDialog: false, // 弹窗
      fireBookDialog: false, // 内容
      activeName: "first",
      cjPersons: [],
      cjPersons1: [],
      cjPersons2: [],
      cjPersons3: [],
      alarmInfo: {
        alarmSingle:{
          alarmTime:'',
          disasterAddress:'',
        }
      },
      selectCjPersons: [],
      selectEqus: [],
      dialogVisible: false,
      falseContent: "",
      spanIndex: [],
      selectRow: {id: this.alarmId},
      form: {msg: ""},
      fileList: [],
      canOper: this.$store.state.canOper,
      fileFormData: {},
      tabsStretch: true,
      isShow: true,
      equs: [],
      selectEquip: true,
      pinkName: '',
      dataFinish:false,  //正常流程进行，下一步火场文书实时更新接口
      falseStr: false,
      singleStateNum: undefined,//当前报警类型
    };
  },
  created() {
    let _this = this;
    _this.handleSearch();
    _this.queryEquipInfo();
    _this.selectCjPersons = [];
    _this.selectEqus = [];
    _this.equs = [];
  },

  mounted() {
    let _this = this;
    _this.fileFormData = new FormData();
    _this.bus.$on('closeDialog', function () {
      _this.fireDocuDialog = false;
      _this.fireBookDialog = false;
    })
  },
  beforeDestroy() {
    let _this = this;
		_this.fireBookDialog = false;
  },
  methods: {
    closeSmokeAlarm() {
      let _this = this;
      _this.$emit("closeSmokeAlarm");
    },
    closeFirePinkAlarm() {
      let _this = this;
      _this.fireDocuDialog = false;
      _this.fireBookDialog = false;
    },
    closeFirePinkAlarm1() {
      let _this = this;
      _this.selectCjPersons = [];
      _this.selectEqus = [];
      _this.equs = [];
      _this.selectEqus.num = 0;
    },
    handleSearch() {
      let _this = this;
      var success = function (resp) {
        _this.cjPersons = resp.data;
        // _this.singleStateNum = resp.alarmSingleDO.singleState
        // if (resp.alarmSingleDO.singleState == 8) {
        //   _this.pinkName = '火眼报警'
        // } else if (resp.alarmSingleDO.singleState == 11) {
        //   _this.pinkName = '防火巡查'
        // } else if (resp.alarmSingleDO.singleState == 10) {
        //   _this.pinkName = '防火门'
        // } else if (resp.alarmSingleDO.singleState == 7) {
        //   _this.pinkName = '消防车道占用报警'
        // } else if (resp.alarmSingleDO.singleState == 9) {
        //   _this.pinkName = '楼道堆物堆料报警'
        // } else if (resp.alarmSingleDO.singleState == 5) {
        //   _this.pinkName = '手报报警调度派单'
        // } else if (resp.alarmSingleDO.singleState == 4) {
        //   _this.pinkName = '隐患报警调度派单'
        // } else if (resp.alarmSingleDO.singleState == 3) {
        //   _this.pinkName = "微信调度派单";
        // } else if (resp.alarmSingleDO.singleState == 0) {
        //   _this.pinkName = '119调度派单'
        // } else if (resp.alarmSingleDO.singleState == 2) {
        //   _this.pinkName = '烟感调度派单'
        // } else if (resp.alarmSingleDO.singleState == 6) {
        //   _this.pinkName = '电动车调度派单'
        // }else if (resp.alarmSingleDO.singleState == 1) {
        //   _this.pinkName = '拉动演练调度派单'
        // }else if (resp.alarmSingleDO.singleState == 12) {
        //   _this.pinkName = '水压报警调度派单'
        // }
        // _this.equs = [];
        // resp.equipment.forEach(function (item) {
        //   item.num = 0;
        //   _this.equs.push(item);
        // });
      };
      _this.http.get(
        "/webapi/writ/isMisdeclaration/" + _this.alarmId,
        {},
        success
      );
      _this.queryEquipInfo()
    },
    queryEquipInfo() {
      let _this = this;
      let success = function (resp) {
        _this.alarmInfo = resp || {};
        if (!_this.alarmInfo.alarmSingle) {
          _this.alarmInfo.alarmSingle = {};
        }
      };
      _this.http.get("/webapi/probe/qureyvide/" + _this.alarmId, {}, success);
    },
    dispatchOrder2() {
      let _this = this;

      if (_this.selectEquip && _this.selectCjPersons.length <= 0) {
        _this.$message.warning("请选择出警人员");
        return;
      }

      // if (_this.selectEquip && _this.selectEqus.length <= 0) {
      //   _this.$message.warning("请选择装备");
      //   return;
      // }
      // let sign = true; //其作用就是选择装备必须选择数量，禁止选择了装备没有选择数量
      // _this.selectEqus.forEach(function (item) {
      //   if (!item.num) {
      //     _this.$message.warning(item.ename+'未选择数量');
      //     sign = false;
      //   }else{
      //     sign = true;
      //   }
      // });
      // if(!sign){  //如果为false则return
      //   return;
      // }

      var alarmCommanderIds = _this.selectCjPersons.map((item) => {
        return item.uid;
      });
      var equipmentIds = _this.selectEqus.map((item) => {
        return item.id;
      });
      var equipmentNumbers = _this.selectEqus.map((item) => {
        return item.num;
      });

      var data = {
        id: _this.alarmId,
        alarmCommanderIds: alarmCommanderIds.join(),
        equipmentIds: equipmentIds.join(),
        equipmentNumbers: equipmentNumbers.join(),
      };

      let phoneList =  _this.selectCjPersons.map((item) => {
        return item.mobile;
      });
      //调取电话
      // let data1 = {
      //   phone:phoneList[0]
      // }
      // let success1 = function(resp){
      //   if(resp.code == '0'){
      //     console.log('与后台拨打电话接口接通！')
      //   }else{
      //     _this.$message.error('拨打电话失败！')
      //   }
      // }
      // console.log(_this.singleStateNum);
      // // 不是防火巡查再掉打电话接口
      // if (_this.singleStateNum != 11) {
      //   _this.http.post("/webapi/writ/voiceCalls", data1, success1);
      // }


      //进行火场文书
      var success = function (resp) {
        if (resp.code == "0") {
          _this.selectEqus=[] //装备
          _this.selectCjPersons=[]  //出警人员
          _this.equs = [];
          _this.$emit('closePinkAlarmDialog');
					// _this.alarmId1 = _this.alarmId;
          // _this.fireDocuDialog = true;
          // _this.fireBookDialog = true;
          _this.$message.success("出警成功！");

          // _this.$emit('closePathOrder');  //关闭上一个烟感弹框 smokeAlarmAuto.vue
          _this.$root.eventHub.$emit('closePinkAlarmDialog');
          // _this.$root.eventHub.$emit('dialogFlase');
        }
      };
      _this.http.post("/webapi/writ/goPoliceAdd", data, success);

    },

    dispathOrder() {
      let _this = this;
      _this.dispathOrderDialog = true;
      _this.$emit("closeAlarmAuto");
    },
    police() {
      let _this = this;
      _this.dispatchOrder2();
    },
    closeFireProbe() {
      let _this = this;
      _this.fireDocuDialog = false;
      _this.fireBookDialog = false;
    },
  },
  watch: {}
};
</script>
<style lang="less" scoped>


.smokeAlarmAuto {

  .policeInfo {
    width: 842px;
    margin: 18px auto;
    border: 1px solid #5a5a5a00;
    border-radius: 10px;

    .policeInfoTop {
      text-align: center;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid rgba(255, 255, 255, 0);
      position: relative;

      .policeNum {
        text-align: right;
      }

      .policeText {
        text-align: left;
      }

      .police {
        height: 280px;
        overflow-y: scroll;
      }
    }

    .lineHei {
      line-height: 32px;
      font-size: 20px;
      color: #fff;
    }

    .policeInfoBot {
      padding: 10px 0 10px 43px;

      .el-form-item {
        margin: 0;
      }

      .piBot {
        span {
          line-height: 46px;
        }

        .piTopText {
          margin: 0 30px 0 0px;
          color: #fff;
          font-size: 16px;
        }
      }

      .piTopImg {
        vertical-align: middle;
      }

      .piBtn {
        width: 132px;
        height: 39px;
        border: 1px solid #ffffff;
        border-radius: 20px;
        background: #3b3b3b;
        color: #fff;
        margin-bottom: 6px;
        margin-right: 23px;
      }

      .el-input {
        width: 156px;
        height: 32px;
        border-radius: 10px;
      }

      .el-textarea__inner {
        border-radius: 10px;
      }
    }
  }

  .policeSub {
    text-align: center;
    margin-top: 20px;
  }
}

.el-dialog__header {
  padding: 0;

  .fireeye-title {
    height: 57px;
    background: #0080DB;
    border-radius: 21px 21px 0px 0px;
    text-align: center;
    line-height: 57px;

    span {
      font-size: 24px;
      font-family: Source Han Sans CN;
      color: #FFFFFF;
    }
  }
}

.el-dialog__body {
  padding: 0px 20px;

  .fireeye-body {
    h1.fireeye-h1 {
      height: 18px;
      line-height: 18px;
      font-weight: normal;
      font-size: 18px;
      color: #333333;
      margin: 22px 0;
      text-align: center;
    }

    .fireeye-bg {
      width: 720px;
      background: rgba(200, 232, 255, 0.3);
      margin: 0px auto;
      padding: 10px 0px;
      border-radius: 8px;
      overflow: hidden;
    }

    .fireeye-info {
      padding: 30px 0px;
      text-align: center;

      i {
        color: #0080DB;
        font-size: 18px;
        margin: 0px 10px;
      }

      span {
        font-size: 16px;
        font-family: Source Han Sans CN;
        color: #333333;
      }
    }

    .fireeye-personnel {
      .el-checkbox {
        margin: 10px 39px;
      }
    }

    .fireeye-num {
      .el-form-item {
        width: 50%;
        height: 40px;
        float: left;
      }

      .el-checkbox-group {
        margin-left: 6%;
      }

      .el-checkbox {
        margin: 15px 10px;
      }

    }
  }
}

.fireeye-footer {
  text-align: center;
  padding-top: 20px;
  padding-bottom: 10px;

  button.el-button {
    width: 206px;
    height: 43px;
    background: #0080DB;
    border-radius: 22px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
  }
}
.fireDoc{
  .el-dialog{
    .el-dialog__header{
      border-radius:18px 18px 0px 0px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/fireBook/firePink.vue